// src/pages/actividades/components/agenda/AgendaHeader.tsx
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui';

interface Props {
  selectedDate: Date;
  viewMode: 'day' | 'week';
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
}

const DAY_NAMES = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
}

function getMonday(d: Date): Date {
  const date = new Date(d);
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  date.setDate(date.getDate() + diff);
  return date;
}

function formatDayLabel(d: Date): string {
  return `${DAY_NAMES[d.getDay()]} ${d.getDate()} de ${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
}

function formatWeekLabel(d: Date): string {
  const monday = getMonday(d);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const mDay = monday.getDate();
  const sDay = sunday.getDate();
  const mMonth = MONTH_NAMES[monday.getMonth()];
  const sMonth = MONTH_NAMES[sunday.getMonth()];

  if (monday.getMonth() === sunday.getMonth()) {
    return `${mDay} – ${sDay} de ${mMonth} ${monday.getFullYear()}`;
  }
  return `${mDay} ${mMonth} – ${sDay} ${sMonth} ${sunday.getFullYear()}`;
}

export function AgendaHeader({ selectedDate, viewMode, onPrev, onNext, onToday }: Props) {
  const isToday = isSameDay(selectedDate, new Date());
  const label = viewMode === 'day'
    ? formatDayLabel(selectedDate)
    : formatWeekLabel(selectedDate);

  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex items-center gap-2">
        <Button variant="outline" size="icon" onClick={onPrev} className="h-8 w-8">
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <Button
          variant={isToday ? 'secondary' : 'outline'}
          size="sm"
          onClick={onToday}
          className="h-8"
        >
          Hoy
        </Button>
        <Button variant="outline" size="icon" onClick={onNext} className="h-8 w-8">
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
      <h2 className="text-sm font-semibold text-foreground">{label}</h2>
    </div>
  );
}
